import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Desligamento',
  path: '/pessoal/pestipodesligamento',
  name: 'pestipodesligamento',
  component: () => import('@/views/pessoal/pestipodesligamento/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEDESLIGAMENTONOVO_MENU_1400701199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Desligamento',
  path: '/pessoal/pestipodesligamento/cadastro/:id?',
  parent: 'pestipodesligamento',
  name: 'pestipodesligamento_create',
  component: () => import('@/views/pessoal/pestipodesligamento/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEDESLIGAMENTONOVO_MENU_1400701199],
  },
  goesToMenu: true,
 },
]
